// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"363":"3c193a9f1b129824","377":"32ef79810a23c3e4","464":"9be05f3a6d1fcd09","648":"e131e5b08fd16222","652":"79f60c167388c8cb","776":"8d3e0c5dda6e3dba"}[chunkId] + ".css";
};